import Button, { ButtonProps } from '@atlaskit/button';
import ArrowRightIcon from '@atlaskit/icon/core/arrow-right';
import React, { FC } from 'react';
import { translationKeys, useTranslation } from 'services/localization';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';

const styles = css({
  display: 'flex',
  justifyContent: 'flex-end',
  padding: `0 ${token('space.300')}`,
  marginTop: token('space.negative.200'),
  marginBottom: token('space.200'),
});

interface OwnProps extends Pick<ButtonProps, 'onClick' | 'appearance'> {
  isVisible: boolean;
}

const NavigationButton: FC<OwnProps> = ({ isVisible, appearance, onClick }) => {
  const { translate } = useTranslation();
  if (!isVisible) return null;
  return (
    <div css={styles}>
      <Button
        appearance={appearance}
        iconAfter={<ArrowRightIcon label={'arrow-right-icon'} size={'small'} />}
        onClick={onClick}
        testId='navigation-button'
      >
        {translate(translationKeys.GOTO_PREFERENCES_CENTER_BUTTON_LABEL)}
      </Button>
    </div>
  );
};

export default NavigationButton;
